export const widget = {
  users: {
    title: 'Utilisateur(s)',
    header_title: 'Actifs',
    left_title: 'Signataires seul',
    middle_title: 'Signataires double',
    right_title: 'Mobiles',
    other_title: '',
  },
  jobs: {
    title: 'Jobs',
    header_title: "Aujourd'hui",
    left_title: 'ToDo',
    middle_title: 'Done',
    right_title: 'Failed',
    other_title: '',
  },
  deleted_batches: {
    title: 'Liste des lots refusés ou supprimés',
    numlot: 'N° Lot',
    compte: 'Compte',
    montant: 'Montant',
    devise: 'Devise',
    status: 'Statut',
    date: 'Date de refus',
    date_execution: "Date d'exécution",
    user: 'Login',
  },
  treasury_reconciliation: {
    title: 'Rapprochement de trésorerie',
    header_title: "Mouvements bancaires reçus aujourd'hui",
    left_title: 'Mouvements non rapprochés',
    middle_title: 'Prévisions échues',
    right_title: 'Prévisions temporaires',
  },
  treasury_account_control: {
    title: 'Contrôle comptes de trésorerie',
    header_title: 'Comptes gérés en trésorerie',
    left_title: 'Comptes Ok',
    middle_title: 'Comptes KO',
    right_title: 'Solde en valeur OK',
    other_title: 'Solde en valeur KO',
  },
  statistic_statements: {
    title: 'Relevés de compte',
    header_title: 'Comptes gérés',
    left_title: 'Comptes OK',
    middle_title: 'Bloqués',
    right_title: 'Comptes KO',
    other_title: '',
    tabs: {
      releves_compte: 'Relevés de compte',
      comptes_erreur: 'Comptes en erreur',
    },
    datagrid: {
      code: 'Code',
      solde: 'Solde',
      devise: 'Devise',
      date: 'Date de solde',
      status: 'Status',
      fault: 'Blocage',
      compte: "Nom du Compte",
      banque: "Banque"
    },
  },
  current_account: {
    treasury: {
      title: 'Compte courants de trésorerie',
    },
    associate: {
      title: "Compte courants d'associés",
    },
    central: {
      title: 'Compte courants centralisateur',
    },
    tabs: {
      graph: 'Graphique',
      list: 'Liste',
      total: 'Total',
    },
    datagrid: {
      nom: 'Nom',
      date: 'Date',
      montant: 'Montant',
      currency: 'Devise',
    },
  },
  received_files: {
    header_title: 'Fichiers reçus',
    datagrid: {
      flow: 'Flux',
      bank: 'Banque',
      file_format: 'File Format',
      date: 'Date de réception',
    },
  },
  maps_flows: {
    title: 'Répartition des flux',
    filters: {
      placeholder: 'Type de filtre',
      country: 'Pays',
      currency: 'Devise',
    },
    currency: {
      placeholder: "Choix d'une devise",
    },
  },
  statistics_flows: {
    title: 'Statistiques des flux',
  },
  comparative_flows: {
    title: 'Evolution des flux',
  },
  currencyRate: {
    titleRate: 'Taux',
    titleCurrency: 'Cours des devises',
    favori: 'Favoris',
    all: 'Toutes',
    column: {
      name: 'Nom',
      date: 'Date',
      currency: 'Cours',
    },
  },
  repository: {
    title: 'Référentiel',
    header_title: '',
    left_title: 'Sociétés',
    middle_title: 'Comptes',
    right_title: 'Tiers',
    other_title: '',
  },
  '4eyes': {
    title: 'Validation 4 Yeux',
    header_title: 'validation(s)',
    left_title: 'tiers',
    middle_title: 'référentiel',
    right_title: 'utilisateur(s)',
    other_title: 'profil(s)',
  },
  accounting_export: {
    title: 'Export Comptable',
  },
  active_signatory: {
    title: 'Liste Signataires Actifs',
    name: 'Nom',
  },
  active_users: {
    title: 'Liste Users Actifs',
  },
  events: {
    title: 'Journal des Evènements',
  },
  treasury_report: {
    title: 'Impression Etat',
    print: 'Imprimer',
    etat: 'Report',
  },
  treasury_zoom_report: {
    title: 'Impression Etat Zoom',
  },
  treasury_transaction_balance: {
    title: 'Trésorerie - Solde par opération',
    affiche: 'Afficher',
    devise: 'Devise',
    label: 'Libellé',
  },
  workflow: {
    title: 'Gestion des lots',
    header_title: 'Lot(s)',
    left_title: 'Non attribué(s)',
    middle_title: 'Fraud Monitor',
    right_title: 'Parapheur 1',
    other_title: 'Parapheur 2',
  },
  signatory_book: {
    title: 'Mon Parapheur',
    header_title: 'Lots',
    all_signed: 'Pas de lots à signer',
  },

  management: {
    onglet: 'Onglet',
    save: 'Enregistrer le dashboard',
    modify: 'Déverrouiller le dashboard',
    list: 'Séléction de widget',
    tab_error: " (Onglet en erreur)",
    modal: {
      title: 'Liste des widgets',
      add: 'Ajouter',
      delete: 'Supprimer',
    },
  },
  error: {
    errorWidget: 'Erreur de chargement',
    text: 'Une erreur est survenue lors de chargement',
    delete: 'Vous ne pouvez pas supprimer un onglet ouvert',
  },
  groupPosition: {
    title: 'Analyse Groupes',
    column: {
      group: 'Groupe',
      forecast: 'Prévisions',
      balance: 'Soldes',
      liquid_investment: 'Placements Liquides',
      current_account: 'Comptes Courants',
      proper_treasury: 'Trésorerie propre',
      illiquid_investment: 'Placements Non Liquides',
      internal_lending: 'Prêt interco',
      external_lending: 'Prêt Externe',
      net_treasury: 'Trésorerie nette',
    },
  },
  accountStatements: {
    byCompany: {
      title: 'Relevés de compte par société',
      column: {
        societe: 'Société',
        montant: 'Montant',
        devise: 'Devise',
        date: 'Date',
      },
    },
    byBank: {
      title: 'Relevés de compte par banque',
    },
    byCurrency: {
      title: 'Relevés de compte par devise',
    },
  },
  treasury_object: {
    '30_days': '30J',
    '60_days': '60J',
    '90_days': '90J',
    label: 'Tombant dans :',
    investments: 'Echéanciers Placements',
    debts: 'Echéanciers Dettes',
    column: {
      name: 'Référence',
      due_date: 'Date Echéance',
      amount: 'Montant',
      currency: 'Devise',
    },
  },
  certificate: {
    title: 'Echéances certificats',
    column: {
      user_id: 'UserID',
      connector: 'Connecteur',
      signature_date: 'Date Echéance Autosignés',
      signature_date_3skey: 'Date Echéance Signature',
    },
  },
  rules_statements_alert: {
    title: 'Alerte sur relevés de compte',
    columns: {
      code_compte: 'Code compte',
      montant: 'Montant',
      devise: 'Devise',
      category: 'Catégorie',
      label: 'Libellé',
      op_date: 'Date Opé.',
      rule_code: 'Code règle',
      update_timestamp: 'Date de modification',
    },
  },
  balance: {
    balance_value_on_date: 'Soldes en valeur au {{date}} ',
    solde: 'Solde',
    solde_operation: 'Soldes et Prévisions',
    prevision: 'Prévisions',
    affiche: 'Afficher',
  },
}

